import React, { useContext } from 'react';
import { onPasteDetected, prepareParams, sendToFraudCheck } from '../../../common/logic/fraud_check';
import { GeneralContext } from '../../contexts';
import { fraudContext } from '../../../common/contexts';
import { plainText } from "../../../../../common/string_utils";

const resultOpenEndsTextKey = 'openEndTexts';
const resultOpenEndsActionKey = 'openEndCheckAction';

const isNumberOnly = (text) => /^\s*\$?\s*\d+\s*$/.test(text);
const isCustomQuestion = (name) => name.startsWith('QF');
const skipGarbageCheck = (name, text) => isCustomQuestion(name) && isNumberOnly(text);

const checkOpenEnds = (result, nextStep, setFraudProcessing) => {
  const openEndTexts = result[resultOpenEndsTextKey] || {};
  const allEntries = Object.entries(openEndTexts);
  if (!allEntries.length) {
    nextStep();
    return;
  }

  const profanityOnlyTexts = [];
  const regularTexts = [];
  allEntries.forEach(([ name, text ]) => {
    if (skipGarbageCheck(name, text)) {
      profanityOnlyTexts.push(text);
    } else {
      regularTexts.push(text);
    }
  });

  const cleanup = () => {
    delete result[resultOpenEndsTextKey];
    delete result[resultOpenEndsActionKey];
    nextStep();
  };

  if (profanityOnlyTexts.length) {
    result[resultOpenEndsActionKey](
      profanityOnlyTexts, cleanup, setFraudProcessing, [ 'profanity' ]
    );
  } else if (regularTexts.length) {
    result[resultOpenEndsActionKey](regularTexts, cleanup, setFraudProcessing);
  } else {
    cleanup();
  }
};

const OpenEnd = ({ question, updateText }) => {
  const { respondentId, projectId, antiFraud } = useContext(fraudContext);
  const { result } = useContext(GeneralContext);
  const handleUpdateAnswer = (event) => {
    const text = event.target.value;
    if (!result[resultOpenEndsTextKey]) {
      result[resultOpenEndsTextKey] = {};
    }
    result[resultOpenEndsTextKey][question.name] = text;
    result[resultOpenEndsActionKey] = (texts, nextStep, setFraudProcessing, checkMethods) => {
      const fraudParams = prepareParams(
        { antiFraud, projectId, respondentId, checkMethods },
        texts
      );
      sendToFraudCheck(fraudParams, nextStep, setFraudProcessing);
    };

    updateText(text);
  };

  return (
    <textarea
      className="js-text form-field -open-end"
      onChange={ handleUpdateAnswer }
      onPaste={ () => { onPasteDetected(result); } }
      aria-label={ plainText(question.text) }
    />
  );
};

export { OpenEnd, checkOpenEnds, isNumberOnly, isCustomQuestion, skipGarbageCheck };
